export function logout () {
  $cookies.remove('apollo-token')
  $cookies.remove('apollo-token-refresh')
  getAuthUser().value = null
  clearLocalStorage()
}
